export default "__VITE_PUBLIC_ASSET__7f92c002__"